export default[
    {
        path: '/comissionador/trabalhador/cadastro/:trabalhador_id',
        name: 'cadastro do comissioador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/comissionador/trabalhador/lista',
        name: 'lista comissionador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/comissionador/trabalhador/editar/:id/:trabalhador_id',
        name: 'editar comissionador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]